import { useContext } from '@nuxtjs/composition-api'

interface DepartmentLayoutSettings {
  id: string
  enabled: boolean
  options: {
    id: string
    enabled: boolean
    custom?: boolean
  }[]
}

export default function useDepartmentColumns() {
  const { store } = useContext()

  function getColumns(pageId: string) {
    const departmentSettings = store.state.departments.pageLayoutSettings as DepartmentLayoutSettings[]
    const settings = departmentSettings?.find(setting => setting.id === pageId)
    const settingsColumns = (settings?.options || []).filter(column => column.enabled)
      .map(column => column.custom ? 'customFields.' + column.id : column.id) || []
    if (settings?.enabled) return settingsColumns
    return []
  }

  function getValue (value: any|any[]) {
    if (Array.isArray(value)) return value.join(', ')
    if(typeof value === 'object') return 'Unsupported value'
    return value
  }

  function getValueFromResource(resource: any, columnId: string) {
    if (!resource) return ''
    return getValue(resource[columnId] || resource.customFields?.[columnId] || '')
  }

  return {
    getColumns,
    getValue,
    getValueFromResource,
  }
}
